function Audio() {
  return (
    <>
      <h1 className="text-center text-4xl font-bold mt-8">Coming Soon!</h1>
    </>
  );
}

export default Audio;
